const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import VerticalTabsLayout from "./layouts/verticalTabs";
import PeopleGrid from "./layouts/people_grid";
import Featherlight from "./../lib/featherlight";
import Cookies from 'js-cookie';
import PieChartCounter from "./components/PieChartCounter.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #TabsLayout;
    #VerticalTabsLayout;
    #PeopleGrid;
    #slider;
    #utils;
    #$admin;
    #root;
    #hubspot;
    #cmp;

    #counter;

    constructor(
        config,
        builder,
        utils,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 50;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#inPageNav = new InPageNav(this);
        this.#TabsLayout = new TabsLayout(this);
        this.#VerticalTabsLayout = new VerticalTabsLayout(this);
        this.#PeopleGrid = new PeopleGrid(this);

        new PieChartCounter(this);
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        me.#TabsLayout.events();
        me.#VerticalTabsLayout.events();
        me.#PeopleGrid.events();
        me.#slider.setup();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-front",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                "iconbar": {
                    "add": true,
                    "size": 40,

                    "top": [
                        "<a href='/'><i class='fa fa-home'></i></a>",
                        //"<a href='/#/'><i class='fa fa-user'></i></a>"
                    ],
                    "bottom": [
                        //`<a href='https://www.instagram.com/' target='_blank'><i class='fa fa-instagram'></i></a>`,
                        //`<a href='https://www.facebook.com/' target='_blank'><i class='fa fa-facebook'></i></a>`,
                        // `<a href='${this.#config.social.twitter}' target='_blank'><i class='fa fa-twitter'></i></a>`,
                        // `<a href='${this.#config.social.linkedin}' target='_blank'><i class='fa fa-linkedin'></i></a>`,
                        // `<a href='${this.#config.social.youtube}' target='_blank'><i class='fa fa-youtube'></i></a>`
                    ]
                },
                backButton: {},
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                offCanvas: {
                    pageNodetype: 'div#page.site-wrapper'
                },
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": this.#config.homeURL
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );

        $(".laptop-preview__preview").hover(function() {
            $(this).parents(".laptop-preview").find(".laptop-preview__bg").addClass("js-hovered");
        }, function() {
            $(this).parents(".laptop-preview").find(".laptop-preview__bg").removeClass("js-hovered");
        });

        $(".laptop-preview__thumbnail--panMode").on("mousemove", function(e) {
            const $img = $(this);
            const $parent = $img.parents(".laptop-preview");
            const offset = $img.offset();
            const width = $img.width();
            const height = $img.height();
            const x = ((e.pageX - offset.left) / width) * 100;
            const y = ((e.pageY - offset.top) / height) * 100;
            $parent[0].style.setProperty('--x', `${ x }%`);
            $parent[0].style.setProperty('--y', `${ y }%`);
        });
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        me.#slider.show();

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.carouselSpotlight__slide', '.carouselSpotlight');
        // Utils.equalHeight('.quoteSlider__slide', '.quoteSlider');
        Utils.equalHeight('.single_tab__overtab', '.tabbed_section__tabs');

        Utils.equalHeight('.tabbed_section__js', '.tabbed_section');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');

        Utils.equalHeight('.role_card__role', '.builder-layout');
        Utils.equalHeight('.role_card__js', '.builder-layout');

        Utils.equalHeight('.role_card', '.builder-layout');

        this.#TabsLayout.init();
        this.#VerticalTabsLayout.init();

        this.$header.addClass('fixed');
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
            $(window).trigger("resize");
        }, 1000);

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: time,
                        easing: 'linear',
                        step: function () {
                            $me.text(Utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(Utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $('.single_accordion .single_accordion__header').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $('.flexible-accordion .flexible-accordion__header').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.flexible-accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $('a:not([data-featherlight])').each(function(i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)){
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube-nocookie.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                } else if (url.indexOf("vimeo.com/") >= 0 || url.indexOf("player.vimeo.com/") >= 0) {
                    const id = Utils.vimeoParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://player.vimeo.com/video/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                }
            }
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }


    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");
        const taxonomies = {"role": "role", "category" : "category"};

        for(let tax in taxonomies) {
            const slug = taxonomies[tax];
            const pattern = new RegExp("^#/.*"+slug+"/(?<term>[a-z-]*)/?");

            if(window.location.hash.includes(slug)) {
                const match = window.location.hash.match(pattern);

                if(match) {
                    const term = match.groups.term || null;

                    Utils.log(`Found ${tax} hash:`, term);

                    if(term) {
                        kpf.clearHistory();

                        kpf.addFilter("default_settings", (settings, el) => {
                            if(settings.filterData.includes(tax)
                                && settings.filterSelected[tax] == null
                                && this.#config.taxonomies[tax][term]
                            ) {
                                settings.filterSelected[tax] = this.#config.taxonomies[tax][term];
                            }

                            return settings;
                        });
                        Utils.scrollToHash('kpfscroll');
                    }
                }
            }

            $(window).on("hashchange", () => {
                if(window.location.hash.includes(slug)) {
                    const match = window.location.hash.match(pattern);

                    if(match) {
                        const term = match.groups.term || null;

                        Utils.log(`Found ${tax} hash:`, term);

                        if (term && this.#config.taxonomies[tax][term]) {
                            kpf.$el.find(`.kpfsc__filter select[name='${tax}']`).val(this.#config.taxonomies[tax][term]).trigger("change");
                        }
                    }
                }
            });
        }

        kpf.addFilter("scroll_offset", () => this.scrollOffset * -1);

        kpf.$el.parent().filter(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />'
            const $leftArrow = '<i class="fa fas fa-chevron-left" />'
            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: true,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        kpf.addFilter("select2_options", function (options) {
            options.dropdownParent = $(".main-wrapper");

            return options;
        });
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    get CMP() {
        return this.#cmp;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}